import { feathers, type ClientService } from '@feathersjs/feathers'
import authenticationClient from '@feathersjs/authentication-client'
import socketio from '@feathersjs/socketio-client'
import io from 'socket.io-client'
import { type ServiceStores } from '@restify/packages/composables/useStore'
import { type StockLevels, type StockLevelsData } from '@restify/packages/types/typebox/stock-levels.schema'
import { type PiFiscalServiceShape } from '@restify/packages/stores/fiscal'

const host = import.meta.env.VITE_APP_API_BASE as string

// Use Rest for the SSR Server and socket.io for the browser
const connection = socketio(
  io(host, { timeout: 10000, transports: ['websocket'] }),
)

export interface ServiceTypes
  extends Record<keyof ServiceStores, ClientService> {
  ['auth-management']: ClientService
  ['process']: ClientService
  ['stock-levels']: ClientService<StockLevels, StockLevelsData>
  ['checkout']: ClientService
  ['pi-printer']: ClientService
  ['pi-fiscal']: ClientService & PiFiscalServiceShape
  ['push-tokens']: ClientService
  ['push-tokens/vapid-public-key']: ClientService
  ['push-tokens/test']: ClientService
  // Cloudinary upload proxy — used by task acceptance-criteria photo
  // submission. Accepts { uri: base64 } and returns { publicId, bytes }.
  ['upload']: ClientService
}

export const feathersClient = feathers<ServiceTypes>()
  .configure(connection)
  .configure(
    authenticationClient({
      storage: window.localStorage,
      storageKey: 'accessToken',
    }),
  )

// pi-fiscal has Feathers v5 custom methods (getStatus, getTask) that aren't
// auto-discovered through the type system — re-register with the explicit
// methods list so dispatch routes them.
// @ts-expect-error — same pattern as invoice-scan in personal-app
feathersClient.use('pi-fiscal', connection.service('pi-fiscal'), {
  methods: ['find', 'get', 'create', 'getStatus', 'getTask'],
})

export default () => {
  return feathersClient
}
